import type { IconData } from '@stacksjs/iconify-core'

export const fileF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3 0h8l5 4v13a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default fileF
